// New Relic utility functions for user tracking

export function setNewRelicUserAttributes(user) {
  try {
    if (!user) {
      console.warn('[New Relic Utils] User is null or undefined');
      return;
    }

    // Use lowercase window.newrelic (the standard global API)
    if (!window.newrelic || typeof window.newrelic.setCustomAttribute !== 'function') {
      console.warn('[New Relic Utils] window.newrelic or setCustomAttribute is not available');
      return;
    }

    const attributes = {
      userId: user.userName,
    };

    // Set custom attributes on New Relic using the standard global API
    Object.entries(attributes).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        try {
          window.newrelic.setCustomAttribute(key, value);
        }
        catch (e) {
          console.error(`[New Relic Utils] Error setting attribute ${key}:`, e);
        }
      }
      else {
        console.warn(`[New Relic Utils] Skipping attribute ${key} - value is empty (${value})`);
      }
    });
  }
  catch (err) {
    console.error('[New Relic Utils] setNewRelicUserAttributes error:', err);
  }
}
